const EMPTY_LIST = [];

function reservationActionLooksDeleted(row) {
   if (!row || typeof row !== "object") return false;
   const actionRaw =
      row.action ??
      row.status ??
      row.type ??
      row.reservation?.action ??
      row.reservation?.status ??
      row.reservation?.type ??
      "";
   return /(delete|deleted|remove|removed)/i.test(String(actionRaw || ""));
}

export function isReservationSoftDeletedRow(row) {
   if (!row || typeof row !== "object") return false;
   if (reservationActionLooksDeleted(row)) return true;

   return !!(
      row.isDeleted ??
      row.is_deleted ??
      row.deletedAt ??
      row.deleted_at ??
      row.reservation?.isDeleted ??
      row.reservation?.is_deleted ??
      row.reservation?.deletedAt ??
      row.reservation?.deleted_at
   );
}

export function filterSoftDeletedReservationRows(items) {
   if (!Array.isArray(items) || !items.length) return EMPTY_LIST;
   const out = [];
   for (const row of items) {
      if (!isReservationSoftDeletedRow(row)) out.push(row);
   }
   return out;
}

export function extractMonthKeyFromQueryPayload(payload) {
   if (!payload || typeof payload !== "object") return "";
   const range = payload.range || null;
   const from = String(
      range?.startDateFrom ?? range?.from ?? range?.start ?? "",
   ).trim();
   const match = from.match(/^(\d{4}-\d{2})/);
   return match ? match[1] : "";
}

export function shouldHydrateMonthQueryPayload(previousPayload, nextPayload) {
   if (!nextPayload) return false;
   if (previousPayload === nextPayload) return false;
   return true;
}

export function buildMonthSnapshotFromQueryPayload(payload) {
   const items = Array.isArray(payload?.items) ? payload.items : EMPTY_LIST;
   return {
      monthKey: extractMonthKeyFromQueryPayload(payload),
      items,
      range: payload?.range ?? null,
      appliedAt: new Date().toISOString(),
   };
}
